import get from "lodash/get";
import axios from "axios";
import Config from "../constants/Config";

class Enums {

    constructor() {
        this.enums = {
        }


        ;
        this.promise = new Promise((resolve, reject) => {
            this.resolver = (val) => {
                resolve(val);
            }
        });

    }

    init() {

        axios.get(`${Config.baseURL}/api/Enums`).then(enums => {
            this.enums = {...this.enums, ...enums.data};
            Object.entries(this.enums).forEach(([eName, vals]) => {
                this[eName] = {};
                vals.forEach(({id, name}) => {
                    this[eName][name] = id;
                });
            });
            this.resolver(enums);
        });

        return this.promise;
    }

    enumsIntialized() {
        return this.promise;
    }

    getAllEnums() {
        return this.enums;
    }

    getEnum(key) {
        return this.enums[key] || [];
    }

    getEnumBy = (key, ids) => {
        return this.enums[key].filter(x => ids.includes(x.id))
    }


    mapEnums = (e) => e.map(o => {
        return ({
            value: o.id, label: o.displayName
        })
    })

    async fetchEnum(key) {
        await this.init();
        return this.getEnum(key);
    }

    transformValues(values, tableName) {
        const transformedValues = {};

        for (let [key, value] of Object.entries(values)) {

            const fieldInfo = get(this.enumMap, [tableName, key]);
            if (fieldInfo) {
                const enumItem = this.getEnum(fieldInfo.enumName).find(e => e.id === value);

                transformedValues[fieldInfo.fieldName] = enumItem ? enumItem.displayName : value;
            } else {
                transformedValues[key] = value
            }
        }

        return transformedValues;
    };
}

export default new Enums();
